export default __webpack_public_path__ + "static/media/tsu.6fd00d16.svg";